



























































































import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class SignUp extends Vue {
  private publicPath: string = process.env.BASE_URL
  private username: string = ''
  private nickName: string = ''
  private avatar: string = 'img/avatar.png'
  private password: string = ''
  private passwordRules: any = [
    (v: any) => !!v || 'Password is required',
    (v: any) => (v && v.length >= 8) || 'Min 8 characters'
  ]
  private confirmPassword: string = ''
  private confirmPasswordRules: any = [
    (v: any) => !!v || 'Password is required',
    (v: any) => (v && v.length >= 8) || 'Min 8 characters',
    (v: any) =>
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(v) ||
      'The password must contain at least one letter and one number'
  ]
  private confirmError: boolean = false
  private confirmErrorMessage: string = ''
  private showPassword: boolean = false
  private showConfirmPassword: boolean = false
  private valid: boolean = true
  private nameRules: any = [
    (v: any) => !!v || 'Name is required',
    (v: any) => (v && v.length <= 25) || 'Name must be less than 25 characters'
  ]
  private email: string = ''
  private emailRules: any = [
    (v: any) => !!v || 'Email is required',
    (v: any) => /.+@.+\..+/.test(v) || 'Email format is invalid'
  ]
  private checkbox: boolean = false
  private dialog: boolean = false
  private num: number = 4
  private setIntervalId: number = 0
  private btnDisabled: boolean = false
  private btnLoading: boolean = false

  private beforeDestroy() {
    if (this.setIntervalId !== 0) {
      clearInterval(this.setIntervalId)
    }
  }

  private back() {
    this.$router.go(-1)
  }

  private login() {
    this.$router.push('login')
  }

  private submit() {
    console.info(this.$refs.form)
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (this.password === this.confirmPassword) {
        this.btnDisabled = true
        this.btnLoading = true

        this.confirmErrorMessage = ''
        this.confirmError = false
        console.info('submit form')
        let obj: object = {}
        obj = {
          username: this.username,
          password: this.password,
          email: this.email,
          nickname: this.nickName,
          avatar: this.avatar
        }

        this.axios({
          method: 'POST',
          url: '/api/v1/users',
          data: obj
        }).then((res: any) => {
          console.info(res)
          if (res.status) {
            console.info('success')
            this.dialog = true
            this.setIntervalId = setInterval(() => {
              this.num--
              if (this.num === 0) {
                this.login()
              }
            }, 1000)
          } else {
            console.warn('network exception')
          }
          this.btnDisabled = false
        })
      } else {
        this.confirmError = true
        this.confirmErrorMessage = 'Two password entries are inconsistent'
      }
    } else {
      console.info('validate false')
    }
  }
}
